// @flow

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import type { Media } from '../../types/keepeekType';
import KeepeekMedia from './KeepeekMedia';
import { openModalWithElements } from '../../state/page/pageService';

type Props = {
  medias: Media[],
  isAlreadyLoaded: boolean,
  openModalWithElements: Function,
}

type State = {
  isModalOpened: boolean,
  itemSelected: number,
}

class KeepeekMediaPatchwork extends React.Component<Props, State> {
  handleClick = (index: number) => {
    this.props.openModalWithElements({
      medias: this.props.medias,
      itemSelected: index,
      isOpen: true,
      isAlreadyLoaded: this.props.isAlreadyLoaded,
    });
  };

  render() {
    return (
      <div className="marketing-media-container">
        {
          this.props.medias
            .sort((a, b) => a.order - b.order)
            .map((media: Media, indexToShow: number) =>
              (
                <div
                  className="image-container"
                  key={media.keepeekId || media.originalUrl}
                  role="button"
                  onClick={() => this.handleClick(indexToShow)}
                >
                  {this.props.isAlreadyLoaded ?
                    <KeepeekMedia
                      openModalWithElements={this.props.openModalWithElements}
                      keepeekMedia={media}
                      disableClick
                      enablePatchwork
                    />
                    :
                    <KeepeekMedia
                      openModalWithElements={this.props.openModalWithElements}
                      keepeekId={media.keepeekId}
                      disableClick
                      enablePatchwork
                    />
                  }
                </div>))
        }
      </div>
    );
  }
}

export default connect(
  null,
  {
    openModalWithElements,
  },
)(KeepeekMediaPatchwork);
